module.exports = __webpack_public_path__ + "static/media/DroneWithBg.311702bb.svg";